// Members.jsx
import React, { useState, useEffect, useContext } from "react";
import MemberForm from "../components/Members/MemberForm";
import MemberList from "../components/Members/MemberList";
import { fetchWorkspaces } from "../api/api";
import { AuthContext } from "../context/AuthContext";
import "./Members.css";

const Members = () => {
  const { user } = useContext(AuthContext);

  const [refresh, setRefresh] = useState(false);
  const [workspaces, setWorkspaces] = useState([]);
  const [workspaceId, setWorkspaceId] = useState(null);

  useEffect(() => {
    if (!user?.id) return;

    const loadWorkspaces = async () => {
      const data = await fetchWorkspaces(user.id);
      setWorkspaces(data || []);
      if (data?.length) setWorkspaceId(data[0].id);
    };

    loadWorkspaces();
  }, [user]);

  return (
    <div className="members-container">
      {/* Header */}
      <div className="members-header">
        <div>
          <h1 className="members-title">Team Members</h1>
          <p className="members-subtitle">
            Manage workspace members and permissions
          </p>
        </div>
        
        {/* Workspace Selector */}
        {workspaces.length > 0 && (
          <div className="workspace-selector-wrapper">
            <label className="selector-label">Workspace</label>
            <div className="selector-container">
              <svg className="selector-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                <polyline points="9 22 9 12 15 12 15 22"></polyline>
              </svg>
              <select
                className="workspace-select"
                value={workspaceId}
                onChange={(e) => setWorkspaceId(Number(e.target.value))}
              >
                {workspaces.map((ws) => (
                  <option key={ws.id} value={ws.id}>
                    {ws.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}
      </div>

      {/* Main Content Grid */}
      <div className="members-grid">
        {/* Add Member Card */}
        <div className="card add-member-section">
          <div className="card-header">
            <h2 className="card-title">
              <svg className="card-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="8.5" cy="7" r="4"></circle>
                <line x1="20" y1="8" x2="20" y2="14"></line>
                <line x1="23" y1="11" x2="17" y2="11"></line>
              </svg>
              Invite Member
            </h2>
          </div>
          <div className="card-body">
            {workspaceId && (
              <MemberForm
                workspace_id={workspaceId}
                onMemberCreated={() => setRefresh(!refresh)}
              />
            )}
          </div>
        </div>

        {/* Members List Card */}
        <div className="card members-list-section">
          <div className="card-header">
            <h2 className="card-title">
              <svg className="card-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
              Team Members
            </h2>
          </div>
          <div className="card-body">
            {workspaceId && (
              <MemberList
                workspace_id={workspaceId}
                refresh={refresh}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Members;